import { render } from "./ExternalRequests.vue?vue&type=template&id=411d53a6&scoped=true"
import script from "./ExternalRequests.vue?vue&type=script&lang=js"
export * from "./ExternalRequests.vue?vue&type=script&lang=js"

import "./ExternalRequests.vue?vue&type=style&index=0&id=411d53a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411d53a6"]])

export default __exports__